import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const apiUrl = import.meta.env.VITE_API_URL;

export const getURL = () => {
  let url = import.meta.env.VITE_SITE_URL ?? // Set this to your site URL in production env.
    import.meta.env.VITE_VERCEL_URL ?? // Automatically set by Vercel.
    'http://localhost:5173/';

  // Make sure to include `https://` when not localhost.
  url = url.startsWith('http') ? url : `https://${url}`;
  // Make sure to include a trailing `/`.
  url = url.endsWith('/') ? url : `${url}/`;

  return url;
};

if (!supabaseUrl || !supabaseAnonKey || !apiUrl) {
  console.error('Environment Variables Status:');
  console.error('VITE_SUPABASE_URL:', supabaseUrl || '[MISSING]');
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '[PRESENT]' : '[MISSING]');
  console.error('VITE_API_URL:', apiUrl || '[MISSING]');
  throw new Error('Missing environment variables');
}

const siteUrl = getURL();

export { apiUrl };

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: window?.localStorage,
    storageKey: 'supabase-auth',
    debug: true
  },
  global: {
    headers: {
      'x-redirect-base': siteUrl,
      'Origin': siteUrl.slice(0, -1)
    }
  }
}); 